import { useExtensionContext } from "~/components/extension.context";

export const UpdateAvailableBanner = () => {
  const [{ extensionUpdatedVersionAvailable }] = useExtensionContext();

  if (!extensionUpdatedVersionAvailable) return null;

  return (
    <div className="flex items-center justify-between bg-orange-400 px-2 py-1 text-orange-950">
      <span>
        A new version of the extension is available on the store. Please update to the latest version to get the best
        experience.
      </span>
    </div>
  );
};
